// Seo.js — méta UNIQUES par route (title + description + Open Graph/Twitter). Sans meta propre,
// toutes les pages du SPA partageaient le même titre/description → mauvaise indexation (contenu
// « dupliqué »). Ici chaque route a ses propres méta, riches en mots-clés. Googlebot exécute le JS
// et react-snap fige le rendu par route → Google indexe le bon titre/description pour chaque page.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { GAMES_SEO_BY_SLUG } from '../gamesSeo';

const DEFAULT = {
  title: 'VertinGo Store — Jeux gratuits, chaînes & communauté',
  description: "Le VertinGo Store : des jeux gratuits jouables direct dans le navigateur, trois chaînes YouTube et une communauté active. Joue, regarde, partage.",
};

const MAP = {
  '/': DEFAULT,
  '/store': {
    title: 'Jeux gratuits en ligne — VertinGo Store',
    description: "Joue gratuitement à Worms, Bomberman, DBZ, Blast Arena et plus, directement dans ton navigateur — en solo ou en ligne avec tes amis, sur PC comme sur mobile. Aucune installation.",
  },
  '/videos': {
    title: 'Vidéos & chaînes YouTube — VertinGo',
    description: "Les dernières vidéos des chaînes VertinGo : anime/manga, science, foot et gaming. Regarde, abonne-toi et rejoins la communauté.",
  },
  '/channels': {
    title: 'Nos chaînes YouTube — Saga Infinie, Horizons, VertinGo',
    description: "Découvre les chaînes YouTube VertinGo : Saga Infinie (anime/manga), Horizons Infinis (science & foot) et VertinGo (gaming & tech).",
  },
  '/communaute': {
    title: 'Communauté VertinGo — replays, chat & classements',
    description: "Rejoins la communauté VertinGo : partage tes meilleurs replays de parties, discute dans le chat, monte dans les classements et défie tes amis.",
  },
  '/classements': {
    title: 'Classements des joueurs — VertinGo',
    description: "Le classement des joueurs VertinGo par niveau : l'XP de tous les jeux compte. Joue, gagne de l'XP et grimpe le top.",
  },
  // Requêtes visées : « créer sa palette », « générateur de combat anime »,
  // « créer son épisode anime », « simulateur de combat Dragon Ball ».
  // Le titre est une PROMESSE, pas une étiquette de rubrique.
  '/palettes': {
    title: 'Crée ta palette de combat anime — ton scénario devient un épisode',
    description: "Choisis deux personnages, le décor et l'angle de tir, écris ton scénario : notre machine simule le combat plan par plan et les meilleures palettes deviennent de vrais épisodes sur la chaîne Saga Infinie. 3 palettes offertes.",
  },
  '/premium': {
    title: 'VertinGo Premium — sans pub, ×2 XP, héros exclusifs',
    description: "Passe VertinGo Premium : navigation sans publicité, ×2 points d'expérience, badge Premium, 5 héros favoris et des cosmétiques exclusifs en jeu.",
  },
  '/salons': {
    title: 'Jouer en ligne — Salons multijoueur VertinGo',
    description: "Crée un salon, invite tes amis et lancez une partie ensemble. Multijoueur temps réel : Worms, Bomberman, DBZ, Blast Arena.",
  },
  '/support': {
    title: 'Support & aide — VertinGo',
    description: "Besoin d'aide sur VertinGo ? Retrouve les réponses aux questions fréquentes et contacte le support.",
  },
  '/about': {
    title: 'À propos de VertinGo',
    description: "VertinGo : une plateforme de jeux gratuits dans le navigateur, des chaînes YouTube et une communauté de joueurs. Notre histoire et notre mission.",
  },
};

function ensureMeta(name, val, isProperty) {
  const sel = isProperty ? `meta[property="${name}"]` : `meta[name="${name}"]`;
  let el = document.querySelector(sel);
  if (!el) { el = document.createElement('meta'); el.setAttribute(isProperty ? 'property' : 'name', name); document.head.appendChild(el); }
  el.setAttribute('content', val);
}

export default function Seo() {
  const { pathname } = useLocation();
  useEffect(() => {
    let m = MAP[pathname] || (pathname.startsWith('/channels/') ? MAP['/channels'] : DEFAULT);
    if (pathname.startsWith('/jeu/')) {
      const g = GAMES_SEO_BY_SLUG[pathname.slice(5)];
      if (g) m = { title: g.seoTitle, description: g.seoDescription };
    }
    if (m.title) { document.title = m.title; ensureMeta('og:title', m.title, true); ensureMeta('twitter:title', m.title, false); }
    if (m.description) { ensureMeta('description', m.description, false); ensureMeta('og:description', m.description, true); ensureMeta('twitter:description', m.description, false); }
  }, [pathname]);
  return null;
}
